import { restClient } from '@/Core'

/**
 * Перехід задачі у «Призупинене» (SPEC-003 §5.5, N7, `TASK_SUSPEND`).
 * `POST /services/tasks/{uuid}/suspend` — тіло не потрібне.
 * Перенос легасі `Ship/Tasks/statusApiActions.js:handleSuspendAction`.
 */
export const SuspendTaskTask = async (uuid: string): Promise<void> => {
    await restClient.post(`/services/tasks/${uuid}/suspend`, { json: {} })
}
